import { render } from "./CreateOptionModal.vue?vue&type=template&id=8727f928&scoped=true&ts=true&lang=pug"
import script from "./CreateOptionModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateOptionModal.vue?vue&type=script&lang=ts&setup=true"

import "./CreateOptionModal.vue?vue&type=style&index=0&id=8727f928&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8727f928"]])

export default __exports__